import { useTranslation } from 'react-i18next'

import { ProfileInfoWidget } from '../../../Widget'

import { PERSONAL_INFO_FIELDS } from './UserProfileWidgetPersonalInfo.constants'

function UserProfileWidgetPersonalInfo({
  canEdit,
  data,
  isSkeleton,
  options,
  onSubmit,
}) {
  const { t } = useTranslation()

  return (
    <ProfileInfoWidget
      canEdit={canEdit}
      config={PERSONAL_INFO_FIELDS}
      data={data}
      isSkeleton={isSkeleton}
      options={options}
      title={t('Widget.PersonalInfoTitleKey')}
      onSubmit={onSubmit}
    />
  )
}

export default UserProfileWidgetPersonalInfo
